import { API_URL, jwtToken } from "../../../context/appContext";
export default async function fetchBots() {
    return fetch(`${API_URL}/api/bot`, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + jwtToken
        }
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => err)
}
